import { render, staticRenderFns } from "./TransferComponent.vue?vue&type=template&id=0d2ab7d5&scoped=true"
import script from "./TransferComponent.vue?vue&type=script&lang=js"
export * from "./TransferComponent.vue?vue&type=script&lang=js"
import style0 from "./TransferComponent.vue?vue&type=style&index=0&id=0d2ab7d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ab7d5",
  null
  
)

export default component.exports